export enum COMMON_PATH {
  HOME = '/'
}

export enum MAIN_PORTAL_PATH {
  HOME = '/',
  DASHBOARD = '/dashboard',
  WALLET = '/wallet',
  ACCOUNT_MANAGEMENT = '/sub-accounts',
  USSD = '/ussd',
  SMS = '/sms',
  OPERATOR_LOOKUP = '/operator-lookup',
  AIRTIME_AND_DATA = '/top-up-and-data',
  ACCOUNT_TRANSFERS = '/account-transfers',
  ONDEMAND = '/ondemand',
  PAYOUT = '/payout',
  MERCHANT_PAYMENT = '/merchant-payment',
  CUSTOMER_VALIDATION = '/customer-validation',
  CUSTOMER_AUTHENTICATION = '/customer-authentication',
  PRODUCTS_AND_SERVICES = '/products-and-services'
}

export enum PORTAL_PATH {
  DASHBOARD = '/dashboard',
  WALLET = '/wallet',
  WALLET_CREDITS_HISTORY = '/wallet/credits-history',
  SUB_ACCOUNTS_MANAGEMENT = '/sub-accounts-management',
  SUB_ACCOUNTS_MANAGEMENT_ACTIVE = '/sub-accounts-management/active',
  SUB_ACCOUNTS_MANAGEMENT_INVITED = '/sub-accounts-management/invited',
  WAP = '/wap',
  WAP_BILLING = '/wap/billing',
  WAP_EDITOR = '/wap/editor',
  WAP_APPS = '/wap/apps',
  WAP_REPORTS = '/wap/reports',
  VOICE = '/voice',
  VOICE_BILLING = '/voice/billing',
  VOICE_EDITOR = '/voice/editor',
  VOICE_APPS = '/voice/apps',
  VOICE_REPORTS = '/voice/reports',
  USSD = '/ussd',
  USSD_BILLING = '/ussd/billing',
  USSD_EDITOR = '/ussd/editor',
  USSD_APPS = '/ussd/apps',
  USSD_REPORTS = '/ussd/reports',
  AIRTIME_AND_DATA = '/top-up-and-data',
  AIRTIME_AND_DATA_REPORTS = '/top-up-and-data/reports',
  AIRTIME_AND_DATA_BILLING = '/top-up-and-data/billing',
  SMS = '/sms',
  SMS_REPORTS = '/sms/reports',
  SMS_BILLING = '/sms/billing',
  OPERATOR_LOOKUP = '/operator-lookup',
  OPERATOR_LOOKUP_BILLING = '/operator-lookup/billing',
  OPERATOR_LOOKUP_REPORTS = '/operator-lookup/reports',
  ACCOUNT_TRANSFERS = '/account-transfers',
  ACCOUNT_TRANSFERS_REPORTS = '/account-transfers/reports',
  ACCOUNT_TRANSFERS_BILLING = '/account-transfers/billing',
  ONDEMAND = '/ondemand',
  ONDEMAND_BILLING = '/ondemand/billing',
  PAYOUT = '/payout',
  PAYOUT_BILLING = '/payout/billing',
  PAYOUT_REPORTS = '/payout/reports',
  MERCHANT_PAYMENT = '/merchant-payment',
  MERCHANT_PAYMENT_BILLING = '/merchant-payment/billing',
  MERCHANT_PAYMENT_REPORTS = '/merchant-payment/reports',
  CUSTOMER_VALIDATION = '/customer-validation',
  CUSTOMER_VALIDATION_BILLING = '/customer-validation/billing',
  CUSTOMER_VALIDATION_REPORTS = '/customer-validation/reports',
  CUSTOMER_AUTHENTICATION = '/customer-authentication',
  CUSTOMER_AUTHENTICATION_BILLING = '/customer-authentication/billing',
  CUSTOMER_AUTHENTICATION_REPORTS = '/customer-authentication/reports',
  CUSTOMER_ENROLLMENT = '/customer-enrollment',
  CUSTOMER_ENROLLMENT_BILLING = '/customer-enrollment/billing',
  CUSTOMER_ENROLLMENT_REPORTS = '/customer-enrollment/reports',
  PRODUCTS_AND_SERVICES = '/products-and-services'
}

export enum PROFILE_CREATION_PATH {
  PROFILE_CREATION = '/profile-creation',
  PROFILE_CREATION_BLOCKED = '/profile-creation-blocked',
  USER_INVITED = '/profile-invitation'
}

export type AUTH_PATH = COMMON_PATH | PROFILE_CREATION_PATH | PORTAL_PATH;

export enum NO_AUTH_PATH {
  LOGOUT_REDIRECT = '/logout-redirect'
}

export enum EXTERNAL_PATH {
  USSD_EDITOR = '/editor'
}

export type PATH = NO_AUTH_PATH | COMMON_PATH | PORTAL_PATH | EXTERNAL_PATH | PROFILE_CREATION_PATH;
